document.addEventListener( 'DOMContentLoaded', function () {
	const nav = document.querySelector( '[data-mobile-nav]' );

	if ( ! nav ) {
		return;
	}

	const body = document.body;
	const toggle = nav.querySelector( '[data-mobile-nav-toggle]' );
	const panel = nav.querySelector( '[data-mobile-nav-panel]' );
	const backdrop = nav.querySelector( '[data-mobile-nav-backdrop]' );
	let lastFocusedElement = null;

	if ( ! toggle || ! panel || ! backdrop ) {
		return;
	}

	const closeButton = nav.querySelector( '[data-mobile-nav-close]' );
	const submenuToggles = Array.from(
		panel.querySelectorAll( '[data-submenu-toggle]' )
	);

	function isDesktop() {
		return window.innerWidth > 1080;
	}

	function getSubmenuForToggle( button ) {
		if ( ! button ) {
			return null;
		}

		const submenuId = button.getAttribute( 'aria-controls' );

		if ( ! submenuId ) {
			return null;
		}

		return document.getElementById( submenuId );
	}

	function closeSubmenu( button ) {
		const submenu = getSubmenuForToggle( button );

		if ( ! submenu ) {
			return;
		}

		button.setAttribute( 'aria-expanded', 'false' );
		submenu.hidden = true;
		submenu.parentElement?.classList.remove( 'is-submenu-open' );
	}

	function openSubmenu( button ) {
		const submenu = getSubmenuForToggle( button );

		if ( ! submenu ) {
			return;
		}

		button.setAttribute( 'aria-expanded', 'true' );
		submenu.hidden = false;
		submenu.parentElement?.classList.add( 'is-submenu-open' );
	}

	function resetSubmenus() {
		submenuToggles.forEach( function ( button ) {
			closeSubmenu( button );
		} );
	}

	function syncState( isOpen ) {
		toggle.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
		panel.setAttribute( 'aria-hidden', isOpen ? 'false' : 'true' );
		panel.hidden = ! isOpen;
		backdrop.hidden = ! isOpen;
		body.classList.toggle( 'is-mobile-nav-open', isOpen );
	}

	function openMenu() {
		lastFocusedElement = nav.ownerDocument.activeElement;
		syncState( true );

		window.requestAnimationFrame( function () {
			if ( closeButton ) {
				closeButton.focus();
				return;
			}

			panel.focus();
		} );
	}

	function closeMenu( restoreFocus ) {
		syncState( false );
		resetSubmenus();

		if ( restoreFocus && lastFocusedElement instanceof HTMLElement ) {
			lastFocusedElement.focus();
		}
	}

	toggle.addEventListener( 'click', function () {
		const isExpanded = toggle.getAttribute( 'aria-expanded' ) === 'true';

		if ( isExpanded ) {
			closeMenu( true );
			return;
		}

		openMenu();
	} );

	if ( closeButton ) {
		closeButton.addEventListener( 'click', function () {
			closeMenu( true );
		} );
	}

	backdrop.addEventListener( 'click', function () {
		closeMenu( true );
	} );

	document.addEventListener( 'keydown', function ( event ) {
		if (
			event.key === 'Escape' &&
			toggle.getAttribute( 'aria-expanded' ) === 'true'
		) {
			closeMenu( true );
		}
	} );

	window.addEventListener( 'resize', function () {
		if ( isDesktop() ) {
			closeMenu( false );
		}
	} );

	submenuToggles.forEach( function ( button ) {
		const submenu = getSubmenuForToggle( button );

		if ( submenu ) {
			submenu.hidden = true;
		}

		button.addEventListener( 'click', function ( event ) {
			event.preventDefault();
			event.stopPropagation();

			if ( isDesktop() ) {
				return;
			}

			const isExpanded = button.getAttribute( 'aria-expanded' ) === 'true';

			if ( isExpanded ) {
				closeSubmenu( button );
				return;
			}

			openSubmenu( button );
		} );
	} );

	panel.querySelectorAll( 'a' ).forEach( function ( link ) {
		link.addEventListener( 'click', function () {
			closeMenu( false );
		} );
	} );
} );
